<template>
  <div class="promo-code-section">
    <div class="promo-code-header">
      <span class="promo-code-title">{{ $t('Bao.payment_promo_code_1') }}</span>
      <a class="promo-code-link" @click.prevent="$emit('open-coupon')">{{ $t('Bao.payment_promo_code_view') }}</a>
    </div>
    <div class="promo-code-input-row">
      <input
        v-model="couponCode"
        class="promo-code-input"
        type="text"
        :placeholder="$t('Bao.payment_promo_code_enter')"
      >
      <button :disabled="!couponCode" class="btn-apply-code" @click="applyCouponCode">
        {{ $t('Bao.payment_promo_code_sign') }}
      </button>
    </div>
    <p class="promo-code-notice">
      {{ $t('Bao.payment_promo_code_notice') }}
    </p>
  </div>
</template>

<script>
import { showNotice, copyText } from '@/utils/tool'
import { getTaskExchange } from '@/api/event'

export default {
  name: 'PromoCode',
  data() {
    return {
      couponCode: ''
    }
  },
  methods: {
    applyCouponCode() {
      getTaskExchange({ task_code: this.couponCode })
        .then((response) => {
          const { code, message } = response.data.data
          if (code) {
            const i18nKey = 'Bao.apply_coupon_' + code
            showNotice(this.$te(i18nKey) ? this.$t(i18nKey) : message)
          }

          if (code === 1) {
            this.$emit('applied', this.couponCode)
            this.couponCode = ''
          }
        })
        .catch((error) => {
          showNotice(error.response.data.msg)
        })
    },
    fillCoupon(code) {
      this.couponCode = code
      copyText(code, code, this.$t('Bao.payment_promo_code_copy'))
    }
  }
}
</script>
